module.exports = __webpack_public_path__ + "media/images/views/candidate/request/primary-check-3add364846dda39301275a0a6d53ef50.png";